import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-ngx-spinner',
  template: `
    <p>
      ngx-spinner works!
    </p>
  `,
  styles: []
})
export class NgxSpinnerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
